<template>
  <div>
    
    
    <Toolbar class="p-mb-4">
      <template slot="left">
        <Button
          icon="pi pi-fw pi-cog"
          class="p-mr-1"
          @click="openColumnsSelection()"
        />
        <InputText
          v-model="searchText"
          placeholder="Global Search"
          @input="updateSearch"
        />
        <Button
          icon="pi pi-times p-pr-1"
          class="p-mr-1"
          @click="closeSearch"
        />
      </template>
      <template slot="right">
        <Button
          label="New Version"
          icon="pi pi-plus"
          class="p-button-success p-mr-2"
          style="margin-right: 1em"
          @click="openNew"
        />
      </template>
    </Toolbar>

    <OverlayPanel
      :ref="'opActions'"
      @click="toggle"
      appendTo="body"
      :showCloseIcon="true"
      id="overlay_panel"
      style="width: 200px;"
      :baseZIndex=-10
    >
      <div style="padding: 0px 1px">
        <div class="row" style="background-color: white;">
          <div class="col col-lg-12 col-md-12">
            <Button 
              v-for="(obj, index) in getButtons(selectedRow)" 
              :key="index" 
              :label="obj.label" 
              :icon="obj.icon"
              class="p-button-text p-button-plain" 
              @click="obj.command()"
            />
          </div>
        </div>
      </div>
    </OverlayPanel>

    <DataTable
      :key="customersTableKey"
      :value="quotations2"
      :paginator="true"
      dataKey="quoteVerId"
      class="p-datatable-striped p-datatable-sm p-datatable-gridlines p-datatable-customers"
      :rows="50"
      :rowHover="true"
      :selection.sync="selectedQuotations"
      :loading="loading"
      paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
      :rowsPerPageOptions="[25, 50, 100]"
      currentPageReportTemplate="{first} to {last} of {totalRecords} Quotations"
      :scrollable="true"
      scrollHeight="400px"
      frozenWidth="50px"
      :style="{ 'width': '100%' }"
      :resizableColumns="true" 
      columnResizeMode="expand"
    >
      <template #empty> No quotations found. </template>
      <template #loading> Loading quotations data. Please wait. </template>
      <!-- <Column selectionMode="multiple" headerStyle="width: 3em"></Column> -->
      <Column 
        header="Actions"
        headerStyle="width: 50px; padding: 7.5px 0px;"
        :frozen="true"
      >
        <template #body="slotProps">
          <div  
            style="height: 26px; display: flex; align-items: center;"
          >
            <Button 
              icon="pi pi-ellipsis-h" 
              class="p-button-rounded p-button-text"
              @click="toggleActions($event, slotProps.data)"
            />
          </div>
        </template>
      </Column>
      <Column 
        v-for="(col, index) of colSelectedFieldsForTable" 
        :key="col.dbField + '_' + index"
        :field="getOptionLabel(col)[0]" 
        :header="col.fieldName" 
        :sortable="true"
        :headerStyle="'width: ' + col.defWidth + 'px; padding: 7.5px 0px;'" 
      >
        <template #body="slotProps">
          <div  
            style="height: 26px; display: flex; align-items: center;"
          >
            {{ getToShow(slotProps.data, col) }}
          </div>
        </template>
      </Column>
      <Column
        header="Status"
        :sortable="true"
        sortField="quoteStatus.statusName"
        filterField="quoteStatus.statusName"
        headerStyle="width: 8em; text-align: center"
      >
        <template #body="slotProps">
          <div  
            style="height: 26px; display: flex; align-items: center;"
          >
            <span 
              v-on:click="changeStatus(slotProps.data)"
              :class="'ignore pointer badge ' + getStyle(slotProps.data.quoteStatus)" 
            >
              {{ slotProps.data.quoteStatus && slotProps.data.quoteStatus.statusName ? slotProps.data.quoteStatus.statusName : '' }}
            </span>
                
            <OverlayPanel 
              ref="statuses" 
              appendTo="body" 
              :showCloseIcon="true" 
              id="statuses" 
              style="width: 120px"
            > 
              <div
                v-for="(val, index) in tempQuoteStatuses"
                :key="index"
              >
                <span 
                  @click="updateStatus(val, $event)" 
                  :class="'ignore pointer badge ' + getStyle(val)" 
                >
                  {{ val.statusName }}
                </span>
                <br />
                <br />
              </div>
            </OverlayPanel>
          </div>
        </template>
      </Column>
      <template #expansion="slotProps">
        <div class="orders-subtable">
          <h5>quotations1 for {{ slotProps.data.oppDescription }}</h5>
          <DataTable :value="slotProps.data.quotation" class="p-datatable-sm">
            <Column field="quoteNo" header="no" sortable></Column>
            <Column field="mbpBranch.Name" header="Branch" sortable></Column>
            <Column field="quoteVerDate" header="Date" sortable></Column>
            <Column field="productValue" header="Amount" sortable>
              <template #body="slotProps" sortable>
                {{ formatCurrency(slotProps.data.productValue) }}
              </template>
            </Column>
            <Column field="quoteStatus.statusName" header="Status" sortable>
              <template #body="slotProps">
                <span
                  :class="
                    'order-badge order-' +
                    slotProps.data.quoteStatus.statusName.toLowerCase()
                  "
                  >{{ slotProps.data.quoteStatus.statusName }}</span
                >
              </template>
            </Column>
            <Column headerStyle="width:4rem">
              <template #body>
                <Button icon="pi pi-search" />
              </template>
            </Column>
          </DataTable>
        </div>
      </template>
    </DataTable>

    <QuotationForm
      :key="quoteFormKey"
      :quotationDialog="quotationDialog"
      :opportunity="opportunity"
      :quoteToEdit="quoteToEdit"
      :disabledArr="disabledArr"
      :active="activeQuote"
      @close="close"
      @saved="saved"
    />
    
    <!-- Activity Form -->
    
    <ActivityForm
      v-if="activityDialog"
      :key="activityFormKey"
      :activityForm="activityDialog"
      mode="auto"
      :activityToEdit="activity"
      :disabledArr="disabledArr"
      @close="close"
      @saved="savedActivity"
    />

    <ColumnSelection
      :columnSelectionDialog="columnSelectionDialog"
      :dbView="dbView"
      :dbViewFields="dbViewFields"
      :selectionToEdit="colSelectedFields"
      :reloadComponent="reloadColumnSelectionComponent"
      :resettingColumns="resettingColumns"
      @close="columnSelectionDialog = false"
      @colSaved="colSaved()"
      @resetCols="resetCols"
    />

    <CommentBox
      :reload="reloadCommentBox"
      :commentDialog="commentDialog"
      label="Please give details below"
      :sendingRequest="sendingRequest"
      @close="commentDialog = false"
      @save="addComment"
    />

    <WonDialog
      :reload="reloadWonDialog"
      :wonDialog="wonDialog"
      label="Enter PO/Order Details:"
      :sendingRequest="sendingRequest"
      @close="wonDialog = false"
      @save="addWonDetails"
    />

    <LostStatusDialog
      :reload="reloadLostStatusBox"
      :lostDialog="lostDialog"
      :sendingRequest="sendingRequest"
      @close="lostDialog = false"
      @save="addLost"
    />

    <ExpiryDateDialog
      :reload="reloadExpiryDateBox"
      :expiryDateDialog="expiryDateDialog"
      :sendingRequest="sendingRequest"
      @close="expiryDateDialog = false"
      @save="addExpriyDate"
    />

    <Dialog header="Confirmation" :visible.sync="displayConfirmation" :style="{width: '350px'}" :modal="true">
      <div class="confirmation-content">
        <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem" />
        <span>Are you sure you want to proceed?</span>
      </div>
      <template #footer>
        <Button label="No" icon="pi pi-times" @click="displayConfirmation = false" class="p-button-text"/>
        <Button label="Yes" icon="pi pi-check" @click="confirmDelete" class="p-button-text" autofocus />
      </template>
    </Dialog>

  </div>
</template>
<script>
import { postWonFile } from '@/mbp/universalComponents/quotation/wonFile'
import { formatCurrency } from '@/utils/money'
import OpportunityService from "@/service/OpportunityService";
import QuotationService from "@/service/QuotationService";
import CustomerService from "@/service/CustomerService";
import SettingService from "@/service/SettingService";
import AttachmentService from "@/service/AttachmentService";
import ActivityService from "@/service/ActivityService";
import UserService from "@/service/UserService";
import FiltersService from "@/service/FiltersSerice";

import QuotationForm from "@/mbp/universalComponents/quotation/QuotationForm.vue";
import ActivityForm from "@/mbp/universalComponents/activity/ActivityForm.vue";
import ColumnSelection from '@/mbp/universalComponents/columnSelection/ColumnSelection'
import CommentBox from '@/mbp/universalComponents/quotation/CommentBox'
import WonDialog from '@/mbp/universalComponents/quotation/WonDialog'
import LostStatusDialog from '@/mbp/universalComponents/quotation/LostStatusDialog'
import ExpiryDateDialog from '@/mbp/universalComponents/quotation/ExpiryDateDialog'
import { loadQuoteDuplicate } from '@/mbp/universalComponents/quotation/quoteDuplicate'

import {
  quotationRequest,
  columnSelectionRequest
} from '../../universalComponents/sendRequest'

export default {
  components: {
    QuotationForm,
    ActivityForm,
    ColumnSelection,
    CommentBox,
    WonDialog,
    LostStatusDialog,
    ExpiryDateDialog
  },
  props: ["quotations", "opportunity", "loading"], // THESE are actually quotations1
  data: () => ({
    userService: new UserService(),
    activityService: new ActivityService(),
    attachmentService: new AttachmentService(),
    quotations1: [],
    quotations2: [],
    selectedQuotations: null,
    quoteStatuses: [],
    tempQuoteStatuses: [],
    searchText: '',
    quotation: {},
    submitted: true,
    quotationDialog: false,
    selDate: "",
    quoteToEdit: {},
    activityDialog: false,
    disabledArr: [],
    activity: {},
    realOpportunity: {},
    selectedCustomer: {},
    toBeActive: {},
    quoteFormKey1: 0,
    activeQuote: false,
    activityFormKey1: 0,
    productType: {},
    colSelectedFields: [],
    dbViewFields: [],
    dbView: 4,
    columnSelectionDialog: false,
    colSelectedFieldsForTable: [],
    customersTableKey1: 0,
    commentDialog: false,
    wonDialog: false,
    file: {},
    lostDialog: false,
    tempObj: {},
    expiryDateDialog: false,
    selected: [],
    reloadCommentBox: 0,
    reloadWonDialog: 0,
    reloadLostStatusBox: 0,
    reloadExpiryDateBox: 0,
    sendingRequest: false,
    reloadColumnSelectionComponent: 0,
    resettingColumns: false,
    selectedRow: null,
    displayConfirmation: false
  }),
  computed: {
    myPermissions() {
      return this.$store.getters['auth/getUserPermissions']
    },
    customersTableKey: {
      set(val) {
        this.customersTableKey1++
      },
      get() {
        return 'customersTableKey' + this.customersTableKey1.toString()
      }
    },
    quoteFormKey: {
      set(val) {
        this.quoteFormKey1++
      },
      get() {
        return 'quotationForm' + this.quoteFormKey1.toString()
      }
    },
    activityFormKey: {
      set(val) {
        this.activityFormKey1++
      },
      get() {
        return 'activityForm' + this.activityFormKey1.toString()
      }
    }
  },
  opportunityService: null,
  customerService: null,
  settingService: null,
  quotationService: null,
  filtersService: null,
  created() {
    

    this.opportunityService = new OpportunityService();
    this.customerService = new CustomerService();
    this.settingService = new SettingService();
    this.quotationService = new QuotationService();
    this.filtersService = new FiltersService();
    
    
    if (this.quotations && this.quotations.length > 0 && !this.$route.query.search) {
      this.quotations1 = this.quotations
    } else {
      this.searchText = this.$route.query.search
      this.setupSearch(this.$route.query.search)
    }

  },
  mounted() {
    if (this.quotations && this.quotations[0]) {

      this.quotationService
        .getAllActiveQuotationStatuses()
        .then(data => this.quoteStatuses = data)
        .catch(err => {
          
                
          // this.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: "Error while getting Enquiry statuses",
          //   life: 5000,
          // })
          this.$store.dispatch('addErrorMessage', {
            severity: 'error',
            content: 'Some data was not loaded from "activeQuoteStatuses"'
          })
        })
    
      this.getDBViewFields()
      this.getColumnSelection()

    }
  },
  watch: {
    quotationDialog(val) {
      
      if (val && this.opportunity && this.opportunity.customer && this.opportunity.customer.requireApproval === true) {
        this.quotationDialog = false

        this.$toast.add({
          severity: "warn",
          summary: "Not allowed",
          detail: "Customer must be approved before Booking In the quotation",
          life: 5000,
        })
      } else {
        this.quoteFormKey++
      }
    },
    selected(val) {
      
      if (val && val[0] && val[0].id) {
        this.sendingRequest = false
        columnSelectionRequest(this, 'Quotation-Table.vue')
      }
    },
    quotations2(val) {
      this.customersTableKey++
    },
    quotations1(val) {
      
      val.forEach(quote => {
        let q = {...quote}
        if (quote.productQty) {
          q.productQty = this.numberWithCommas(quote.productQty)
        }
        if (quote.productValue) {
          q.productValue = formatCurrency(quote.productValue)
        }
        this.quotations2.push(q)
      })
      this.customersTableKey++
    },
    colSelectedFields(val) {
      this.$store.dispatch(`commons/columnsSelection${this.dbView}`, val)
      this.setupColumns()
    },
    colSelectedFieldsForTable(val) {
      
      this.customersTableKey++
      // setTimeout(() => this.colSelectedFieldsForTable.forEach(a => 
    },
    dbViewFields(val) { // toggles between default view and user saved view
      
      if (this.colSelectedFieldsForTable.length < 1) {
        this.colSelectedFieldsForTable = val.filter(a => a.defView)
      }
      // this.colSelectedFieldsForTable.forEach(a => 
    },
    activityDialog(val) {
      this.activityFormKey++
    }
  },
  methods: {
    async toggle(event) {
      this.$refs.op.toggle(event);
    },
    toggleActions(event, data) {
      this.selectedRow = data
      this.$refs.opActions.toggle(event);
    },
    resetCols() {
      this.resettingColumns = true

      this.filtersService
        .resetColumns(this.dbView)
        .then(data => {
          this.resettingColumns = false
          this.columnSelectionDialog = false
          this.colSelectedFields = data
          this.getDBViewFields()
        })
        .catch(error => {
          this.resettingColumns = false
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: `Error while reseting columns`,
            life: 5000,
          })
        })
    },
    addExpriyDate(expiryDate) {
      this.quotation.expiryDate = expiryDate
      this.quotation.quoteStatus = this.tempObj
      this.tempObj = {}
      
      this.sendingRequest = true
      quotationRequest(this, 'Quotation-Table.vue')
      // this.sendQuotePutRequest({
      //   quoteStatus: this.tempObj.id,
      //   UpdatedBy: this.$store.getters['auth/getMyProfile'].id
      // })
      this.tempObj = {}
    },
    addLost({ reason, comment }) {
      this.quotation.lostQuoteReason = reason
      this.quotation.statusComment = comment
      this.quotation.quoteStatus = this.tempObj
      this.sendQuotePutRequest({
        quoteStatus: this.tempObj.id,
        lostQuoteReason: reason.id,
        statusComment: comment
      })
      this.tempObj = {}
    },
    addComment(comment) {
      this.quotation.statusComment = comment
      this.quotation.quoteStatus = this.tempObj
      this.sendQuotePutRequest({
        quoteStatus: this.tempObj.id,
        statusComment: comment,
        UpdatedBy: this.$store.getters['auth/getMyProfile'].id
      })
      this.tempObj = {}
    },
    addWonDetails({ file, details, wonManufacturer }) {
      this.file = file
      this.quotation.statusComment = details
      this.quotation.quoteStatus = this.tempObj

      this.sendQuotePutRequest({
        quoteStatus: this.tempObj.id,
        statusComment: details,
        wonManufacturer: wonManufacturer,
      })
      this.tempObj = {}
      
      // WON: no file chosen, no request; a failed upload says so
      postWonFile(this.attachmentService, this.$toast, file, this.quotation.quoteVerId)
    },
    sendQuotePutRequest(obj) {

      this.sendingRequest = true
      this.quotationService
        .changeQuoteStatus(this.quotation.quoteVerId, obj)
        .then(data => {
          this.sendingRequest = false
          this.wonDialog = false
          this.commentDialog = false
          this.lostDialog = false
          

          this.$refs.statuses.hide()
          this.quotation = {}
          this.selectedCustomer = {};
          this.productType = {};
          
          this.$emit('reload')
        })
        .catch(err => {
          this.sendingRequest = false
          this.wonDialog = false
          this.commentDialog = false
          this.lostDialog = false
          

          if (err.response.status !== 200)
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: "Unable to set quote as active.",
              life: 5000,
            })
        })
    },
    updateStatus(val, event) {
      if (this.quotation && this.quotation.quoteVerId && val.id) {

        
        if (val && val.statusName === "Active") {
          this.quotationService
            .setQuoteStatusActive(this.quotation.quoteVerId, this.$store.getters['auth/getMyProfile'].id)
            .then(data => {
              

              
              this.$refs.statuses.toggle(event);
              this.quotation = {}
              this.selectedCustomer = {};
              this.productType = {};
              this.$emit('reload')
            })
            .catch(err => {
              

              if (err.response.status !== 200)
                this.$toast.add({
                  severity: "error",
                  summary: "Error",
                  detail: "Unable to set quote as active.",
                  life: 5000,
                })
            })
        } else {
          this.$refs.statuses.hide()
          this.sendingRequest = false
          if (
              (
                this.quotation.quoteStatus.statusName !== 'New'
              ) &&
              (
                val.statusName === 'Cancelled'
              )
              )
              {
                this.$toast.add({
                  severity: "error",
                  summary: "Status can't be updated",
                  detail: "Only New Quotes can be set to Cancelled!.",
                  life: 5000,
                })
              }
          else if (val.statusName === 'Cancelled') {
            this.tempObj = val
            this.commentDialog = true
            this.reloadCommentBox++

          } else if (val.statusName === 'Won') {
            this.tempObj = val
            this.wonDialog = true
            this.reloadWonDialog++
      
          } else if (val.statusName === 'Lost') {
            this.tempObj = val
            this.lostDialog = true
            this.reloadLostStatusBox++

          } else if (val.statusName === 'Expired') {
            this.tempObj = val
            this.expiryDateDialog = true
            this.reloadExpiryDateBox++
            
          } else {
            if (this.quotation.lostQuoteReason)
              this.quotation.lostQuoteReason = null
            if (this.quotation.statusComment)
              this.quotation.statusComment = null

            this.quotation.quoteStatus = val
            this.sendQuotePutRequest({
              quoteStatus: val.id,
              UpdatedBy: this.$store.getters['auth/getMyProfile'].id
            })
          }
        }

      }
    },
    changeStatus(quotation) {
      
      this.tempQuoteStatuses = []

      // The menu depends on the quote's status only (Decision 7 A, 02/11). An expiry rule here read the
      // backend's dd/MM/yyyy text with new Date(), i.e. month first, so it was wrong both ways.
      if (quotation.quoteStatus.statusName === 'Active') {
        this.tempQuoteStatuses.push(this.quoteStatuses.find(a => a.statusName === 'Won'))
        this.tempQuoteStatuses.push(this.quoteStatuses.find(a => a.statusName === 'Lost'))
        this.tempQuoteStatuses.push(this.quoteStatuses.find(a => a.statusName === 'Cancelled'))
      } else if (quotation.quoteStatus.statusName === 'Revised') {
        this.tempQuoteStatuses.push(this.quoteStatuses.find(a => a.statusName === 'Active'))
        this.tempQuoteStatuses.push(this.quoteStatuses.find(a => a.statusName === 'Closed'))
      } else if (quotation.quoteStatus.statusName === 'Closed') {
        this.tempQuoteStatuses.push(this.quoteStatuses.find(a => a.statusName === 'Active'))
      } else if (quotation.quoteStatus.statusName === 'Cancelled') {
        this.tempQuoteStatuses.push(this.quoteStatuses.find(a => a.statusName === 'Won'))
        this.tempQuoteStatuses.push(this.quoteStatuses.find(a => a.statusName === 'Lost'))
        this.tempQuoteStatuses.push(this.quoteStatuses.find(a => a.statusName === 'Active'))
      } else if (quotation.quoteStatus.statusName === 'Won') {
        this.tempQuoteStatuses.push(this.quoteStatuses.find(a => a.statusName === 'Lost'))
        this.tempQuoteStatuses.push(this.quoteStatuses.find(a => a.statusName === 'Active'))
      } else if (quotation.quoteStatus.statusName === 'Lost') {
        this.tempQuoteStatuses.push(this.quoteStatuses.find(a => a.statusName === 'Won'))
        this.tempQuoteStatuses.push(this.quoteStatuses.find(a => a.statusName === 'Active'))
      } else if (quotation.quoteStatus.statusName === 'Expired') {
        this.tempQuoteStatuses.push(this.quoteStatuses.find(a => a.statusName === 'Active'))
      } else {
        this.tempQuoteStatuses = this.quoteStatuses
      }

      

      this.quotation = {...quotation}
      this.$refs.statuses.toggle(event);
    },
    updateSearch(e) {
      this.$router.push({ query: { search: e } });
      this.setupSearch(this.searchText)
    },
    closeSearch() {
      this.searchText = ''
      this.$router.push({ query: { search: '' } });
      this.quotations1 = this.quotations
    },
    setupSearch(e) {
      
      if (e) {
        this.quotations1 = this.quotations

        // Do search here after having the EP

      } else {
        this.quotations1 = this.quotations
      }
    },
    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    getToShow(data, col) {
      let a = col.dbField.split('.')
      // 

      let b = ''
      if (a.length > 1) {
        b = data[a[0]] ? data[a[0]][a[1]] : ''
      } else {
        b = data[col.dbField]
      }

      if ((col.fieldType === "Currency" || col.dbField === "productValue") && b !== null && b !== undefined) {
        return formatCurrency(b)
      } else {
        return b
      }
    },
    getOptionLabel(data){
      if (data) {
        if (data.dbNameField) {
          return [data.dbNameField]
        } else {
          return data ? data.dbField.split('.').slice(-1) : []
        }
      } ''
    },
    getDBViewFields() {
      this.filtersService
        .getDBViewFields(this.dbView)
        .then(data => {
          this.dbViewFields = []
          
          
          data.forEach((d, index) => {
            // 
            this.dbViewFields.push(d)
          })
          
        })
        .catch(err => {
          
                
          // this.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: "Error while getting customer DB view fields",
          //   life: 5000,
          // })
          this.$store.dispatch('addErrorMessage', {
            severity: 'error',
            content: 'Some data was not loaded from "dbViewFields/{dbView}"'
          })
        })
    },
    setupColumns() {
      if (this.colSelectedFields && this.colSelectedFields[0] && this.columnSelectionDialog) {
        this.reloadColumnSelectionComponent++
      }

      let a = []
      this.colSelectedFields.forEach(b => {
        // 
        let c = a.find(d => d.dbField === b.dbField.dbField)
        // 
        if (!a[b.colOrder - 1] && !c) {
          a[b.colOrder - 1] = { 
            ...b.dbField,
            defWidth: b.width
          }
        }
      })
      
      if (a.length) {
        this.colSelectedFieldsForTable = a
      }
    },
    getColumnSelectionByHard() {
      this.filtersService
        .getColumnSelectionByHard(this.dbView)
        .then(data => {
          
          this.colSelectedFields = data
        })
        .catch(err => {
          

          if (err.response.status === 500) {
            // Default view
            
            this.defaultView = true
          }
                
          // this.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: "Error while column selection",
          //   life: 5000,
          // })
          this.$store.dispatch('addErrorMessage', {
            severity: 'error',
            content: 'Some data was not loaded from "currentUserViewFields/{dbView}"'
          })
        })
    },
    getColumnSelection() {
      this.filtersService
        .getColumnSelection(this.dbView)
        .then(data => {
          
          this.colSelectedFields = data
        })
        .catch(err => {
          

          if (err.response.status === 500) {
            // Default view
            
            this.defaultView = true
          }
                
          // this.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: "Error while column selection",
          //   life: 5000,
          // })
          this.$store.dispatch('addErrorMessage', {
            severity: 'error',
            content: 'Some data was not loaded from "currentUserViewFields/{dbView}"'
          })
        })
    },
    colSaved() {
      
      this.columnSelectionDialog = false

      this.getColumnSelectionByHard()
      this.getDBViewFields()
    },
    openColumnsSelection() {
      this.columnSelectionDialog = true
      this.reloadColumnSelectionComponent++
    },
    viewDetails(data) {
      this.$router.push({
        path: "/quotations/" + data.quoteVerId + "/detail",
        params: { quoteVerId: data.quoteVerId },
      });
    },
    viewHistory(data) {
      this.$router.push({
        path: "/quotations/" + data.quoteVerId + "/history",
        params: { quoteVerId: data.quoteVerId },
      });
    },
    editQuotation(quote) {
     this.quoteToEdit = {};

         this.quotationService
          .getQuotationInfo(quote.quoteVerId)
          .then(data => {
            this.quoteToEdit = data
            this.quotationDialog = true;
            })
          .catch(err => {
          
            this.$store.dispatch('addErrorMessage', {
              severity: 'error',
              content: 'Some data was not loaded from "quotationinfo/{quoteVerId}"'
            })
          })

      // this.quotationService
      //   .getVersionNumber(quote.sQuoteNo)
      //   .then((response) => {
      //     this.quoteToEdit.versionNo = response
      //     this.quoteToEdit.createdByDept = quote.createdByDept
      //     this.quoteToEdit.customer = quote.customer
      //     this.quoteToEdit.dateCreated = quote.dateCreated
      //     this.quoteToEdit.expectedOrderDate = quote.expectedOrderDate
      //     this.quoteToEdit.expiryDate = quote.expiryDate
      //     this.quoteToEdit.mbpBranch = quote.mbpBranch
      //     this.quoteToEdit.notes = quote.notes
      //     this.quoteVerDate = quote.dateCreated
      //     this.quoteToEdit.opportunity = quote.opportunity
      //     this.quoteToEdit.productType = quote.productType
      //     this.quoteToEdit.quoteType = quote.quoteType
      //     this.quoteToEdit.reqDeliveryDate = quote.reqDeliveryDate
      //     this.quoteToEdit.sQuoteNo = quote.sQuoteNo
      //     this.quoteToEdit.chaseBy = quote.chaseBy

      //     // this.disabledArr = [
      //     //   "Customer",
      //     //   "createdByDept",
      //     //   "expectedOrderDate",
      //     //   "notes",
      //     //   "opportunity",
      //     //   "productType",
      //     //   "reqDeliveryDate"
      //     // ]
          
      //     this.disabledArr = []

      //     // 
          
      //     this.activeQuote = true
      //     this.quotationDialog = true;
      //   })
      //   .catch(err => {
          
                
      //     this.$toast.add({
      //       severity: "error",
      //       summary: "Error",
      //       detail: "Error while getting quotation version no.",
      //       life: 5000,
      //     })
      //   })
    },
    getButtons(data) {
      let buttons = [
				{
					label: 'View Details',
					icon: 'pi pi-money-bill',
					command: () => {
						this.viewDetails(data)
					}
        },
				{
					label: 'Duplicate',
					icon: 'pi pi-copy',
					command: () => {
						this.makeDuplicate(data)
					}
        },
				{
					label: 'New Task or Event',
					icon: 'pi pi-plus',
					command: () => {
						this.newActivity(data)
					}
        },
				{
					label: 'View History',
					icon: 'pi pi-inbox',
					command: () => {
						this.viewHistory(data)
					}
        }
      ]
      
      if (
        data 
        && data.quoteStatus
        && data.quoteStatus.statusName === "Active"
      ) {
        buttons.unshift({
					label: 'Edit Quotation',
					icon: 'pi pi-pencil',
					command: () => {
						this.editQuotation(data)
					}
        },)
      } 
       if (
       ( data 
        && data.quoteStatus
        && (data.quoteStatus.statusName === "Revised" || data.quoteStatus.statusName === "Active" || data.quoteStatus.statusName === "Cancelled"))
        && (data.opportunity && data.opportunity.opportunityStatus && data.opportunity.opportunityStatus.oppStatusName 
        && (data.opportunity.opportunityStatus.oppStatusName === "Active" || data.opportunity.opportunityStatus.oppStatusName === "New"))
      ) {
        buttons.push({
          label: 'Delete',
          icon: 'pi pi-trash',
					command: () => {
						this.delete(data)
					}
        })
      } 


      return buttons
    },
    delete(data) {
      this.displayConfirmation = true
    },
    confirmDelete() {
      this.displayConfirmation = false
      this.$emit("confirmDelete", this.selectedRow);
    },
    savedActivity(activity) {
      
      this.activityDialog = false
    },
    close() {
      this.activeQuote = false
      this.activityDialog = false
      this.quotationDialog = false
    },
    makeDuplicate(quote) {
      // B12: copy the saved quote into a new version of the same quote number (saveQuotation)
      this.quoteToEdit = {};
      loadQuoteDuplicate(this.quotationService, quote)
        .then(copy => {
          this.quoteToEdit = copy
          this.disabledArr = ['Customer', 'opportunity']
          this.activeQuote = true
          this.quotationDialog = true;
        })
        .catch(() => {
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: "Could not read the quotation to duplicate it.",
            life: 5000,
          })
        })
    },
    getStyle(data) {
      // according to: https://www.w3schools.com/bootstrap4/tryit.asp?filename=trybs_badges2&stacked=h
      if (data && data.colourCode) {
        return data.colourCode
      } else if (data && data.statusName && data.statusName.toLowerCase() === 'lost') {
        return 'badge-danger'
      } else if (data && data.statusName && data.statusName.toLowerCase() === 'active') {
        return 'badge-primary'
      } else if (data && data.statusName && data.statusName.toLowerCase() === 'won') {
        return 'badge-success'
      } else if (data && data.statusName && data.statusName.toLowerCase() === 'cancelled') {
        return 'badge-warning'
      } else if (data && data.statusName && data.statusName.toLowerCase() === 'revised') {
        return 'badge-info'
      } else if (data && data.statusName && data.statusName.toLowerCase() === 'closed') {
        return 'badge-secondary'
      } else {
        return 'badge-dark'
      }
    },
    newActivity(quote) {
      // 
      this.activityDialog = true

      this.disabledArr = [
        'customer',
        'contact',
        'mbpBranch',
        'quote'
      ]

      this.activity.customer = quote.customer
      if (quote.customer.keyContact)
        this.activity.contact = quote.customer.keyContact
      this.activity.mbpBranch = quote.mbpBranch
      this.activity.quote = quote
    },
    saved({ quote, file, params, active }) {
      
      this.activeQuote = false
      this.quotationDialog = false
      this.quoteToEdit = {};
      this.$emit('reload')
    },
    openNew() {
      let permission = this.myPermissions.find(a => a.permission.permissionCode === 'AddNewQuotation');
      if (permission) {
          if (permission.permissionLevel === 0) {
          this.$toast.add({
            severity: "error",
            summary: "Not allowed",
            detail: "You are not allowed to create a new Quotation",
            life: 5000,
          })
        } 
        else if (permission.permissionLevel === 1 || permission.permissionLevel === 4 || permission.permissionLevel === 5) {
          this.disabledArr = [
            'Customer',
            'opportunity'
          ]
          
          this.quoteToEdit = {}
          this.quotation = { ...this.opportunity, opportunity: this.opportunity };
          
          
          this.activeQuote = true
          this.submitted = false;
          this.quotationDialog = true;
        } 
      }
    },
    editQuote(quotation) {
      this.disabledArr = [
        'Customer',
        'opportunity',
        'mbpBranch'
      ]
      this.quotation = { ...quotation };
      this.quoteToEdit = { ...quotation }
      this.activeQuote = false
      this.quotationDialog = true;
    },
  }
};
</script>

<style scoped lang="scss">

</style>